import { type MaybeRefOrGetter, toValue } from 'vue'
import useApi from '../../components/js/Composables/useApi'
import type { Contract } from '../../Types/contract'

export function useRestructuringApi(restructuringId: MaybeRefOrGetter<number | null>) {
  const { getJSON, postJSON } = useApi()

  async function getContracts(): Promise<Contract[]> {
    const id = toValue(restructuringId)
    if (!id) {
      return []
    }

    return await getJSON(`contracts/restructuring/${id}/contracts`)
  }

  async function cancel(): Promise<void> {
    const id = toValue(restructuringId)
    if (!id) {
      return
    }

    await postJSON(`contracts/restructuring/${id}/cancel`)
  }

  return {
    cancel,
    getContracts,
  }
}
